import MessageTemplateDomainService from "../MessageTemplate/MessageTemplate.service";
import AutomatedScheduleDomainService from "../AutomatedSchedule/AutomatedSchedule.service";
import CampaignSendBehaviorDomainService from "../CampaignSendBehavior/CampaignSendBehavior.service";
export default class CampaignDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { message: MessageTemplateDomainService.fromJSON(json.message), createdDate: json.createdDate && new Date(json.createdDate), startedDate: json.startedDate && new Date(json.startedDate), stoppedDate: json.stoppedDate && new Date(json.stoppedDate), startDate: json.startDate && new Date(json.startDate), endDate: json.endDate && new Date(json.endDate), automatedSchedule: json.automatedSchedule &&
                AutomatedScheduleDomainService.fromJSON(json.automatedSchedule), sendBehavior: CampaignSendBehaviorDomainService.fromJSON(json.sendBehavior) });
    }
}
export class CampaignLiteDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { startDate: json.startDate && new Date(json.startDate), endDate: json.endDate && new Date(json.endDate) });
    }
}
